// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/Users/heyuheng/workspace/cj/admin_api/admin-frontend/src/models/taskCenter';
import model_2 from '/Users/heyuheng/workspace/cj/admin_api/admin-frontend/src/models/upload';
import model_3 from '/Users/heyuheng/workspace/cj/admin_api/admin-frontend/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'taskCenter', model: model_1 },
model_2: { namespace: 'upload', model: model_2 },
model_3: { namespace: '@@initialState', model: model_3 },
} as const
